import { useT } from "src/internationalization";

type ViewMode = "street" | "map";

type ViewModeSwitchButtonProps = {
  viewMode: ViewMode;
  onViewModeChange: (viewMode: ViewMode) => void;
};

const ViewModeSwitchButton = ({ viewMode, onViewModeChange }: ViewModeSwitchButtonProps) => {
  const t = useT();
  return (
    <div className="flex items-center overflow-hidden">
      <button
        onClick={() => onViewModeChange("street")}
        className={`px-4 py-2 text-sm font-medium border-1 border-r-0 cursor-pointer ${
          viewMode === "street" ? "bg-[#91daee]" : "bg-white"
        }`}
      >
        {t("widget.googleMap.button.streetView")}
      </button>
      <button
        onClick={() => onViewModeChange("map")}
        className={`px-4 py-2 text-sm font-medium border-1 cursor-pointer ${
          viewMode === "map" ? "bg-[#91daee]" : "bg-white"
        }`}
      >
        {t("widget.googleMap.button.map")}
      </button>
    </div>
  );
};

export default ViewModeSwitchButton;
